export default "__VITE_ASSET__BVnVOSeH__"